import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.GetContractsForSigning.IRequest;
type Params = Api.Core.Contract.GetContractsForSigning.IParams;
type Response = Api.Core.Contract.GetContractsForSigning.IResponse;
type Headers = Api.Core.Contract.GetContractsForSigning.IHeaders;
const url = '/api/Sales/Contract/GetContractsForSigning/:signingType';
export default async function contractGetContractsForSigningApi(
  params: Params,
  query?: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, { signingType: params.signingType }, query),
    headers: getDefaultHeaders(),
  });
}
